import { useMutation, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';

const refusal = z.object({ error: z.string() });

/**
 * Talent Pool's interim recruiter sign-in by password
 * (plans/talent-2026-10-22/8_password_sign_in.md). Both calls answer with a
 * session cookie on success; every refusal carries a sentence to show as it is.
 */
async function postPassword(path: '/login' | '/setup', body: Record<string, string>) {
  const response = await fetch(`/auth/password${path}`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  });
  if (response.ok) return;
  const answer = refusal.safeParse(await response.json().catch(() => null));
  throw new Error(answer.success ? answer.data.error : `That failed (${response.status}).`);
}

export function usePasswordLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (credentials: { email: string; password: string }) =>
      postPassword('/login', credentials),
    onSuccess: () => queryClient.invalidateQueries(),
  });
}

export function useSetPassword() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { token: string; password: string }) => postPassword('/setup', input),
    onSuccess: () => queryClient.invalidateQueries(),
  });
}
